/**
 * @flow
 * @relayHash a190d5382f06c5e3d47cf371e3b32fa2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OverrideReportPageQueryVariables = {|
  first?: ?number,
  after?: ?string,
  last?: ?number,
  before?: ?string,
  sort?: ?string,
|};
export type OverrideReportPageQueryResponse = {|
  +overrideReport: ?{|
    +actions: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +document: ?{|
            +pk: ?number,
            +name: string,
            +category: {|
              +name: string
            |},
            +bloc: {|
              +name: string
            |},
          |},
          +overrideAction: ?{|
            +pk: ?number,
            +actionDate: ?string,
            +comment: ?string,
            +user: ?{|
              +pk: ?number,
              +firstName: string,
              +lastName: string,
              +title: ?string,
            |},
          |},
        |},
        +cursor: string,
      |}>,
      +pageInfo: {|
        +hasNextPage: boolean,
        +hasPreviousPage: boolean,
        +startCursor: ?string,
        +endCursor: ?string,
      |},
      +totalCount: ?number,
    |},
    +error: ?{|
      +statusCode: ?number,
      +message: ?string,
    |},
  |}
|};
export type OverrideReportPageQuery = {|
  variables: OverrideReportPageQueryVariables,
  response: OverrideReportPageQueryResponse,
|};
*/


/*
query OverrideReportPageQuery(
  $first: Int
  $after: String
  $last: Int
  $before: String
  $sort: String
) {
  overrideReport(sort: $sort) {
    actions(first: $first, after: $after, last: $last, before: $before) {
      edges {
        node {
          document {
            pk
            name
            category {
              name
              id
            }
            bloc {
              name
              id
            }
            id
          }
          overrideAction {
            pk
            actionDate
            comment
            user {
              pk
              firstName
              lastName
              title
              id
            }
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
    error {
      statusCode
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "last",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "before",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort",
    "type": "String"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last",
    "type": "Int"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = [
  v4
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actionDate",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "comment",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "pageInfo",
  "storageKey": null,
  "args": null,
  "concreteType": "PageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasNextPage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasPreviousPage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "startCursor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "endCursor",
      "args": null,
      "storageKey": null
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "message",
      "args": null,
      "storageKey": null
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v16 = [
  v4,
  v15
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "OverrideReportPageQuery",
  "id": "e460b7f78f2d56307a6c7cb248bb43dc",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "OverrideReportPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "overrideReport",
        "storageKey": null,
        "args": v1,
        "concreteType": "OverrideReportType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "actions",
            "storageKey": null,
            "args": v2,
            "concreteType": "OverrideReportConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "OverrideReportEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentWithOverrideType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v3,
                          v4,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CategoryType",
                            "plural": false,
                            "selections": v5
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "bloc",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BlocType",
                            "plural": false,
                            "selections": v5
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "overrideAction",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OverrideActionType",
                        "plural": false,
                        "selections": [
                          v3,
                          v6,
                          v7,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserType",
                            "plural": false,
                            "selections": [
                              v3,
                              v8,
                              v9,
                              v10
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  v11
                ]
              },
              v12,
              v13
            ]
          },
          v14
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "OverrideReportPageQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "overrideReport",
        "storageKey": null,
        "args": v1,
        "concreteType": "OverrideReportType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "actions",
            "storageKey": null,
            "args": v2,
            "concreteType": "OverrideReportConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "OverrideReportEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DocumentWithOverrideType",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "document",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "DocumentType",
                        "plural": false,
                        "selections": [
                          v3,
                          v4,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "category",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CategoryType",
                            "plural": false,
                            "selections": v16
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "bloc",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BlocType",
                            "plural": false,
                            "selections": v16
                          },
                          v15
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "overrideAction",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OverrideActionType",
                        "plural": false,
                        "selections": [
                          v3,
                          v6,
                          v7,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserType",
                            "plural": false,
                            "selections": [
                              v3,
                              v8,
                              v9,
                              v10,
                              v15
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  v11
                ]
              },
              v12,
              v13
            ]
          },
          v14
        ]
      }
    ]
  }
};
})();
node.text = "query OverrideReportPageQuery(\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $sort: String\n) {\n  overrideReport(sort: $sort) {\n    actions(first: $first, after: $after, last: $last, before: $before) {\n      edges {\n        node {\n          document {\n            pk\n            name\n            category {\n              name\n              id\n            }\n            bloc {\n              name\n              id\n            }\n            id\n          }\n          overrideAction {\n            pk\n            actionDate\n            comment\n            user {\n              pk\n              firstName\n              lastName\n              title\n              id\n            }\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        endCursor\n      }\n      totalCount\n    }\n    error {\n      statusCode\n      message\n    }\n  }\n}\n";
(node/*: any*/).hash = 'bbad42f862ee10bd02b583ff1850d0ea';
module.exports = node;
